import { Outlet } from 'react-router-dom';
import { Container } from 'reactstrap';
import HeaderPortal from '../components/wrapper/HeaderPortal';
import FooterPortal from '../components/wrapper/FooterPortal';
//import fondoLogo from '../assets/images/bg/fondo-blanco.png'
import fondoLogo from '../assets/images/bg/marcaaguasynergy.png'


const FullLayout = () => {
  return (
      <main
          className="d-flex flex-column min-vh-100"
          // style={{
          //   backgroundImage: `url(${fondoLogo})`, // Aquí se establece la imagen de fondo
          //   backgroundSize: 'cover',  // Esto ajusta la imagen para que cubra todo el fondo
          //   backgroundPosition: 'center center',  // Centra la imagen en el contenedor
          //   backgroundRepeat: 'no-repeat',  // Evita que se repita la imagen
          // }}
        >
      {/* HEADER FIJO */}
      <div className="position-fixed top-0 start-0 end-0 bg-white border-bottom" style={{ zIndex: 1030 }}>
        <HeaderPortal />
      </div>

      {/* CONTENIDO CON MARGEN ARRIBA (después del header) */}
      <Container fluid className="flex-grow-1 mt-5 pt-3">
        <Outlet />
      </Container>

      {/* FOOTER (al fondo, solo visible con scroll) */}
      <div className="mt-auto">
        <FooterPortal />
      </div>
    </main>
  );
};

export default FullLayout;
